// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HERO_BG from "../assets/Images/bg.jpg";
import { getHomepageContent } from "../api/cmsApi";

function extractHeroContent(payload) {
  const source = payload?.data || payload || {};
  const heroBlock = source?.Hero || {};
  const buttons = source?.Buttons || {};

  const title =
    heroBlock?.title ||
    "REPEXO";

  const subtitle =
    heroBlock?.subtitle ||
    "Headhunting auf höchstem Niveau.";

  const description =
    heroBlock?.description ||
    "Wählen Sie den passenden Fachbereich, um fortzufahren.";

  return {
    title,
    subtitle,
    description,
    buttons: {
      salesTitle: buttons?.SalesButtonTitle || "Fachbereich",
      salesText: buttons?.SalesButtonText || "REPEXO Sales",
      medicalTitle: buttons?.MedicalButtonTitle || "Fachbereich",
      medicalText: buttons?.MedicalButtonText || "REPEXO Medical",
    },
  };
}

export default function Home() {
  const [cmsHero, setCmsHero] = useState(null);

  useEffect(() => {
    // Initial CMS connection call; UI mapping can be added page by page.
    getHomepageContent()
      .then((payload) => {
        setCmsHero(extractHeroContent(payload));
      })
      .catch((error) => {
        console.error("Homepage CMS fetch failed:", error);
      });
  }, []);

  return (
    <>
      <div className="relative min-h-screen overflow-hidden bg-black text-white">
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-70"
          style={{ backgroundImage: `url(${HERO_BG})` }}
        />

        {/* Subtle vignette + top fade (more premium look) */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/20 to-black/20" />

        {/* Content */}
        <div className="relative z-10 min-h-screen">
          <div className="container-app flex min-h-screen flex-col items-center justify-center px-4">
            {/* Brand */}
            <div className="text-center mb-24">
              <h1 className="text-6xl sm:text-7xl md:text-8xl  tracking-[0.12em] font-[600]">
                {cmsHero?.title || "REPEXO"}
              </h1>

              <p className="mx-auto mt-6 max-w-3xl text-lg sm:text-xl md:text-2xl font-semibold text-white/90 tracking-wide">
              {cmsHero?.subtitle || "Headhunting auf höchstem Niveau."}
              </p>

              <p className="mt-4 text-sm sm:text-base text-white/70">
                {cmsHero?.description || "Wählen Sie den passenden Fachbereich, um fortzufahren."}
              </p>
            </div>

            {/* Split buttons area */}
            <div className="mt-14 w-full max-w-4xl">
              <div className="relative grid grid-cols-1 items-center gap-10 sm:grid-cols-2 sm:gap-16">
                {/* Vertical divider */}
                <div className="pointer-events-none absolute left-1/2 hidden -translate-x-1/2 sm:block top-[-20px] bottom-[-120px] w-[2px] bg-white/100" />

                {/* Medical */}
                <div className="text-center">
                  <p className="mb-4 text-lg sm:text-xl font-normal text-white/85">
                    {cmsHero?.buttons?.medicalTitle || "Fachbereich"}
                  </p>

                  <Link
                    to="/medical"
                    style={{
                      transition: "background-color 700ms ease, color 700ms ease",
                    }}
                    className="
                      inline-flex items-center justify-center
                      rounded-full
                      bg-white px-6 py-2
                      text-sm sm:text-lg font-medium text-black/80
                      hover:bg-black hover:text-white
                      focus:outline-none focus:ring-2 focus:ring-white/60
                      min-w-[160px]
                    "
                  >
                    {cmsHero?.buttons?.medicalText || "REPEXO Medical"}
                  </Link>
                </div>

                {/* Sales */}
                <div className="text-center">
                  <p className="mb-4 text-lg sm:text-xl font-normal text-white/85">
                    {cmsHero?.buttons?.salesTitle || "Fachbereich"}
                  </p>
                  <Link
                    to="/sales"
                    style={{
                      transition: "background-color 700ms ease, color 700ms ease",
                    }}
                    className="
                      inline-flex items-center justify-center
                      rounded-full
                      bg-white px-6 py-2
                      text-sm sm:text-lg font-medium text-black/80
                      hover:bg-black hover:text-white
                      focus:outline-none focus:ring-2 focus:ring-white/60
                      min-w-[160px]
                    "
                  >
                    {cmsHero?.buttons?.salesText || "REPEXO Sales"}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <StatsAndLogosMarquee /> */}
    </>
  );
}
